import create from "zustand";
import { devtools } from "zustand/middleware";

const modalPortalState = (set, get) => ({
  isOpened: false,
  content: null,
  options: null,
});

const useModalPortalState = create(devtools(modalPortalState));

export function openModal(content, options= {}) {
  useModalPortalState.setState(() => ({
    isOpened: true,
    content,
    options
  }));
}

export function closeModal() {
  useModalPortalState.setState(() => ({
    isOpened: false,
    content: null,
    options: null
  }));
}

export const modalPortal = {
  open: openModal,
  close: closeModal,
}

export default useModalPortalState;
